import { PopoverTrigger as OrigPopoverTrigger } from '@chakra-ui/react'
import { FC, ReactNode } from 'react'

// https://github.com/chakra-ui/chakra-ui/issues/5896
export const PopoverTrigger: FC<{ children: ReactNode }> = OrigPopoverTrigger
